import { useSnackbar } from 'notistack'
import { useCallback, useContext, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { routeNames } from 'src/modules/core/constants/routeNames'
import { LoadingWrapperContext } from 'src/modules/core/context'
import { AuthContext } from 'src/modules/user/context'
import { AuthService } from 'src/services/auth.service'
import { TokenService } from 'src/services/token.service'

export function Impersonate() {
  const [hasStarted, setHasStarted] = useState(false)
  const [searchParams] = useSearchParams()
  const { enqueueSnackbar } = useSnackbar()
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const { authenticateUser, logoutUser } = useContext(AuthContext)
  const { enableLoading, disableLoading, setLoadingMessage } = useContext(LoadingWrapperContext)

  const handleFailure = useCallback(() => {
    disableLoading()
    logoutUser()
    enqueueSnackbar(formatMessage({ id: 'login.error.unknown' }), { variant: 'error' })
    navigate(routeNames.login.path)
  }, [disableLoading, logoutUser, enqueueSnackbar, formatMessage, navigate])

  const exchangeAndLogin = useCallback(async () => {
    enableLoading()
    setLoadingMessage('Authenticating...')

    const code = searchParams.get('code')
    if (!code) {
      handleFailure()
      return
    }

    try {
      const tokens = await AuthService.exchangeImpersonationCode(code)
      if (!tokens.access_token || !tokens.refresh_token) {
        handleFailure()
        return
      }

      TokenService.getInstance().setToken(tokens.access_token, tokens.refresh_token)
      authenticateUser()
      window.location.href = routeNames.dashboard.path
    } catch (_error) {
      handleFailure()
    }
  }, [authenticateUser, enableLoading, handleFailure, searchParams, setLoadingMessage])

  useEffect(() => {
    if (hasStarted) return
    setHasStarted(true)
    exchangeAndLogin()
  }, [exchangeAndLogin, hasStarted])

  return null
}
